/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC, type PropsWithChildren } from 'react';

import classNames from 'classnames';

export const ToolItemIcon: FC<PropsWithChildren & { size?: 'small' }> = ({
  children,
  size,
}) => (
  <div
    className={classNames('flex justify-center items-center cursor-pointer', {
      'w-[24px] h-[24px]': size !== 'small',
      'w-[16px] h-[16px]': size === 'small',
    })}
    onClick={e => e.stopPropagation()}
  >
    {children}
  </div>
);
